import apiClient from "../config/api";

export const aiService = {
  generateNextWhy: async (problemStatement, previousWhys) => {
    try {
      const response = await apiClient.post(`/ai/generate-next-why`, {
        problemStatement,
        previousWhys,
      });
      return response.data;
    } catch (error) {
      console.error("Error generating next why:", error);
      throw error;
    }
  },

  generateWhyQuestion: async (context) => {
    try {
      const response = await apiClient.post(`/ai/generate-why-question`, {
        context,
      });
      return response.data;
    } catch (error) {
      console.error("Error generating why question:", error);
      throw error;
    }
  },

  generateFlowchart: async (prompt) => {
    try {
      const response = await apiClient.post(`/ai/generate-flowchart`, {
        prompt,
      });
      return response.data;
    } catch (error) {
      console.error("Error generating flowchart:", error);
      throw error;
    }
  },

  analyzeHazardImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await apiClient.post(
        `/ai/analyze-hazard-image`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error analyzing hazard image:", error);
      throw error;
    }
  },

  analyzeObservationImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await apiClient.post(
        `/ai/analyze-observation-image`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error analyzing observation image:", error);
      throw error;
    }
  },
};
